import { render } from "./CTextCard.vue?vue&type=template&id=037f8568"
import script from "./CTextCard.vue?vue&type=script&lang=js"
export * from "./CTextCard.vue?vue&type=script&lang=js"

import "./CTextCard.vue?vue&type=style&index=0&id=037f8568&lang=css"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__